/** 优惠券菜单 **/
<template>
  <div class="couponNav">
    <ul class="clear">
      <!--({{item.num ? item.num : 0}})-->
      <li v-for="(item,index) in data" :class="actionFn=== index?'actionLi':''">
        <router-link :to="item.router">{{item.name}}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'xk-couponNav',
    props: ['data'],
    computed: {
      actionFn: function () {
        switch (this.$route.path) {
          case '/coupon/nused':
            return 0
          case '/coupon/used':
            return 1
          case '/coupon/stale':
            return 2
        }
      }
    },
    data () {
      return {}
    },
    methods: {},
    watch: {},
    mounted: function () {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .couponNav {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 150;
    line-height: 3.6rem;
    background-color: #fff;
    width: 100%;
    box-shadow: 0 2px 5px rgba(0, 0, 0, .1);
    li {
      display: inline-block;
      width: 33.333%;
      text-align: center;
      a {
        color: #333;
        font-size: 1.25rem;
      }
    }
    .actionLi {
      a {
        color: #f06553;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// couponNav.vue?4fd61fcc